export default __webpack_public_path__ + "static/media/logo.42001c74.png";